import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { RootState } from "../../../state";
import { Shirt } from "../../../entities/Shirt";
import ItemsList from "../../../components/ItemsList/ItemsList";
import PageControllers from "../../../components/PageControllers/PageControllers";
import CollectionOptionsBar from "../../../components/CollectionOptionsBar/CollectionOptionsBar";

interface MyCollectionProps {
  shirts: Array<Shirt>;
  setPage: Function;
  page: number;
  lastPage: number | undefined;
  setOrderBy: Function;
  itemsPerPage: number;
  setItemsPerPage: Function;
}

const MyCollection = ({
  shirts,
  setPage,
  page,
  lastPage,
  setOrderBy,
  itemsPerPage,
  setItemsPerPage,
}: MyCollectionProps) => {
  const [ownPage, setOwnPage] = useState<boolean>(false);

  const loginData = useSelector((state: RootState) => state.login);

  const { userId } = useParams();

  useEffect(() => {
    if (userId !== undefined && parseInt(userId) !== loginData.userId) {
      setOwnPage(false);
    } else {
      setOwnPage(true);
    }
  }, [userId]);

  return (
    <Box aria-label="My collection">
      <CollectionOptionsBar
        setOrderBy={setOrderBy}
        isOwnProfile={ownPage}
        targetUser={ownPage ? loginData.userId : Number(userId)}
      />
      <ItemsList
        shirts={shirts}
        showAdd={ownPage}
        justify="flex-start"
        shouldShowUser={false}
      />
      {shirts.length > 0 && (
        <PageControllers
          setPage={setPage}
          currentPage={page}
          lastPage={lastPage}
          withNumbers={true}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
        />
      )}
    </Box>
  );
};

export default MyCollection;
